export {
  BATCH_SEARCHABLE_SELECT_PROPS,
  batchCourseGroup,
  batchSearchableSelectProps,
  formatBatchDisplayLabel,
  formatBatchOptionDetails,
} from '../domain/batch/batchDisplayLabel';

/**
 * Sort batches by course name, then batch name, then start date (newest first).
 */
export function sortBatchesForDisplay(batches) {
  return [...batches].sort((a, b) => {
    const courseA = (a.course?.courseName || '').toLowerCase();
    const courseB = (b.course?.courseName || '').toLowerCase();
    if (courseA !== courseB) return courseA.localeCompare(courseB);
    const nameA = (a.batchName || '').toLowerCase();
    const nameB = (b.batchName || '').toLowerCase();
    if (nameA !== nameB) return nameA.localeCompare(nameB, undefined, { numeric: true });
    const dateA = a.startDate ? new Date(a.startDate).getTime() : 0;
    const dateB = b.startDate ? new Date(b.startDate).getTime() : 0;
    return dateB - dateA;
  });
}
